import { createContext, useContext } from "react";

interface ShadowRootContextValue {
  shadowRoot: ShadowRoot;
  containerEl: HTMLDivElement;
}

export const ShadowRootContext = createContext<ShadowRootContextValue | null>(null);

export const useShadowRoot = (): ShadowRootContextValue => {
  const ctx = useContext(ShadowRootContext);
  if (!ctx) throw new Error("useShadowRoot must be used within ShadowRootProvider");
  return ctx;
};
